export default "__VITE_ASSET__C70y6MH0__"